export class CalendarEventEmployee {
  public constructor (
    readonly id: number | undefined,
    readonly name: string,
    readonly capacity: string | undefined,
    readonly isFloater: boolean,
    readonly planningGroupName: string | undefined,
    readonly comment: string,
    readonly start: Date,
    readonly end: Date,
    readonly number: number | undefined,
    readonly detailId?: number
  ) {}

  public updateComment (comment: string): CalendarEventEmployee {
      return new CalendarEventEmployee(
        this.id,
        this.name,
        this.capacity,
        this.isFloater,
        this.planningGroupName,
        comment,
        this.start,
        this.end,
        this.number,
        this.detailId
      )
  }
}
